import { useState } from 'react';

import Input from '@cartwhl/ui/atoms/Input';
import GoButton from '@cartwhl/ui/input/GoButton';

import { authStore } from 'stores/global';

import AuthPageLayout from './AuthPageLayout';

export default function RequestResetPasswordPage() {
  const [loading, setLoading] = useState(false);

  return (
    <AuthPageLayout title="Reset password">
      <form
        className="grid grid-cols-2 gap-x-4 gap-y-6 pb-10"
        onSubmit={async (e) => {
          e.preventDefault();
          const email = e.currentTarget.email.value;
          setLoading(true);
          await authStore.requestPasswordReset(email);
          setLoading(false);
        }}
      >
        <Input
          label="Your email"
          name="email"
          placeholder="Email"
          className="col-span-2"
        />
        <GoButton className="col-span-2 mt-8" loading={loading} type="submit">
          Reset password
        </GoButton>
      </form>
    </AuthPageLayout>
  );
}
